export default __webpack_public_path__ + "static/media/arcgis-hub.a052e855.svg";